import { Component, OnInit, ViewChild } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Define } from 'src/app/models/define';
import { UserService } from 'src/app/services/user.service';
import { AuthService } from '@app/services/auth.service';

@Component({
  selector: 'app-personal-settings',
  templateUrl: './personal-settings.component.html',
  styleUrls: ['./personal-settings.component.css']
})
export class PersonalSettingsComponent implements OnInit {
  @ViewChild(MatAccordion) accordion: MatAccordion;
  closingDays: { id: number, value: string }[];
  passwordChanged = true;

  _selectClosingDayIndex: number;
  get selectClosingDayIndex(): number {
    return this._selectClosingDayIndex;
  }
  set selectClosingDayIndex(value: number) {
    this._selectClosingDayIndex = value;
  }

  constructor(private _userService: UserService, private _auth: AuthService, private _snackBar: MatSnackBar) {
    this.initializeDisplay();
  }

  ngOnInit(): void {
    this._auth.getUser().then(u => {
      this.passwordChanged = (u.passwordChanged === undefined || u.passwordChanged);
    });
  }

  async initializeDisplay() {
    //締め日選択項目の設定
    this.closingDays = new Array();
    Define.closingDaysList.length
    for (let i = 0; i < Define.closingDaysList.length; i++) {
      this.closingDays.push({ id: Define.closingDaysList[i].id, value: Define.closingDaysList[i].value });
    }
    this.selectClosingDayIndex = this.closingDays[0].id;

    //締め日設置読み込み,表示
    let currentUser = await this._auth.getUser();
    let closingDay = currentUser.closingDay ?? Define.closingDay.DayOf15;//DBに設定がなければ初期値15日締め
    closingDay = closingDay == Define.closingDay.Undefined ? Define.closingDay.DayOf15 : closingDay;
    console.log("saved closing day:" + closingDay);
    this.selectClosingDayIndex = closingDay;
  }

  async saveClosingDaySettting() {
    console.log("save closing day setting:" + this.selectClosingDayIndex);

    let currentUser = await this._auth.getUser();
    currentUser.closingDay = this.selectClosingDayIndex;
    this._userService.updateUser(currentUser);

    console.log("Complete");
    this.showSnackbar("締め日設定を保存しました！");
  }

  async showSnackbar(text: string){
    this._snackBar.open(text, undefined, { duration: 2 * 1000 });
  }
}
